import { render, staticRenderFns } from "./elements.vue?vue&type=template&id=0456ac7a&lang=pug"
import script from "./elements.vue?vue&type=script&lang=js"
export * from "./elements.vue?vue&type=script&lang=js"
import style0 from "./elements.vue?vue&type=style&index=0&id=0456ac7a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports